import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface PromptEditorProps {
  template: string;
  negativePrompt: string;
  onTemplateChange: (value: string) => void;
  onNegativePromptChange: (value: string) => void;
  generatedPrompt?: string;
}

export function PromptEditor({
  template,
  negativePrompt,
  onTemplateChange,
  onNegativePromptChange,
  generatedPrompt
}: PromptEditorProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="template">Template</Label>
        <Textarea
          id="template"
          value={template}
          onChange={(e) => onTemplateChange(e.target.value)}
          placeholder="Enter your prompt template with --placeholders--"
          rows={4}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="negative">Negative Prompt</Label>
        <Textarea
          id="negative"
          value={negativePrompt}
          onChange={(e) => onNegativePromptChange(e.target.value)}
          placeholder="Enter negative prompt"
          rows={4}
        />
      </div>

      {generatedPrompt && (
        <div className="mt-4 p-4 bg-gray-700 rounded-lg">
          <h3 className="text-lg font-medium mb-2">Prompt Preview:</h3>
          <p className="whitespace-pre-wrap">{generatedPrompt}</p>
        </div>
      )}
    </div>
  );
} 